import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
	selector: 'app-payment-icons',
	templateUrl: './payment-icons.component.html',
	styleUrls: ['./payment-icons.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class PaymentIconsComponent implements OnInit {

	constructor() { }

	ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/icons/payment-icons/payment-icons.component.ts